import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'zzal-debug.firebaseapp.com',
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: 'zzal-debug',
  storageBucket: 'zzal-debug.appspot.com',
  messagingSenderId: '506025144376',
  appId: '1:506025144376:web:b0d1996d330631d79736cd',
  measurementId: 'G-R9KCG3SZ4Y',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const firestore = firebase.firestore();

// GoogleAuthProvider 클래스를 authentication 라이브러리에서 사용
const g_provider = new firebase.auth.GoogleAuthProvider();
const f_provider = new firebase.auth.FacebookAuthProvider();

// GoogleAuthProvider 사용시마다 구글 팝업 띄움
g_provider.setCustomParameters({ prompt: 'select_account' });
f_provider.setCustomParameters({ display: 'popup' });

// 페이스북 추가 시 여기서
export const signinWithGoogle = () => auth.signInWithPopup(g_provider);
export const signinWithFacebook = () => auth.signInWithPopup(f_provider);

export default firebase;
